import { useCallback, useState } from "react";

// Aplica mascara de CEP no formato 00000-000
export function maskCep(value) {
  const digits = (value || "").replace(/\D/g, "").slice(0, 8);
  if (digits.length <= 5) return digits;
  return `${digits.slice(0, 5)}-${digits.slice(5)}`;
}

// Consulta o ViaCEP. Retorna { ok, data?, error? }.
// error: "invalid" (formato), "notfound" (CEP inexistente). Erros de rede lancam excecao.
export async function lookupCep(cep) {
  const clean = (cep || "").replace(/\D/g, "");
  if (clean.length !== 8) return { ok: false, error: "invalid" };
  const res = await fetch(`https://viacep.com.br/ws/${clean}/json/`);
  if (!res.ok) throw new Error("network");
  const d = await res.json();
  if (d.erro) return { ok: false, error: "notfound" };
  return {
    ok: true,
    data: {
      street: d.logradouro || "",
      district: d.bairro || "",
      city: d.localidade || "",
      state: d.uf || "",
    },
  };
}

// Hook reutilizavel: preenche street/district/city/uf no form a partir do CEP.
// Mantem Numero e Complemento intactos. Nao bloqueia o cadastro em caso de falha.
export function useCepLookup(setForm) {
  const [cepLoading, setCepLoading] = useState(false);
  const [cepError, setCepError] = useState("");
  const [cepSuccess, setCepSuccess] = useState(false);

  const handleCepLookup = useCallback(
    async (cepValue) => {
      setCepError("");
      setCepSuccess(false);
      const clean = (cepValue || "").replace(/\D/g, "");
      if (clean.length !== 8) return;
      setCepLoading(true);
      try {
        const res = await lookupCep(clean);
        if (res.ok) {
          setForm((f) => ({
            ...f,
            street: res.data.street || f.street,
            district: res.data.district || f.district,
            city: res.data.city || f.city,
            state: res.data.state || f.state,
          }));
          setCepSuccess(true);
        } else {
          setCepError("CEP não localizado.");
        }
      } catch {
        // Falha de rede: nao bloqueia, permite preenchimento manual.
      } finally {
        setCepLoading(false);
      }
    },
    [setForm]
  );

  return { cepLoading, cepError, cepSuccess, handleCepLookup };
}
